import React from "react";
import { DatePicker } from "react-advance-jalaali-datepicker";
import "./style.scss";

export const Datepicker = ({
  className,
  onChange,
  value,
  disabled = false,
  format = "jYYYY/jMM/jDD",
  placeholder,
  containerClassName,
  title,
  required = false,
}) => {
  return (
    <div className={`datepicker_parent ${containerClassName || ""}`}>
      {title && (
        <p className="title">
          {title}
          {required && <span className="required">*</span>}
        </p>
      )}
      <div className={`datepicker_container ${className || ""}`}>
        <DatePicker
          cancelOnBackgroundClick={true}
          inputComponent={(props) => <input type="text" {...props} />}
          placeholder={placeholder}
          format={format}
          onChange={(unix, formatted) => onChange(formatted)}
          preSelected={value}
        />
        <i className="fal fa-calendar-alt datepicker_icon text-muted" />
      </div>
    </div>
  );
};
